import * as React from "react";
import { withRouter, RouteComponentProps, Link } from "react-router-dom";
import { Tabs, Tab } from "@blueprintjs/core";
import { slice } from "lodash";
import { ThunkDispatch } from "../../../types/redux";
interface IProps extends RouteComponentProps<any> {
  selectedTab: string;
  dispatch: ThunkDispatch;
}

const ConfigTabs = ({ selectedTab, location, dispatch }: IProps) => {
  const pathParts = location.pathname.split("/");
  const basePathParts = slice(pathParts, 0, pathParts.length - 1);
  const dimensionsPath = [...basePathParts, "dimensions"].join("/");
  const attributesPath = [...basePathParts, "attributes"].join("/");
  const outputsPath = [...basePathParts, "outputs"].join("/");

  return (
    <Tabs
      id="action-nav-tabs"
      selectedTabId={selectedTab}
      animate={false}
      large={true}
    >
      <Tab id="dimensions">
        <Link to={dimensionsPath}>Dimensions Master</Link>
      </Tab>
      <Tab id="attributes">
        <Link to={attributesPath}>Attributes Master</Link>
      </Tab>
      <Tab id="outputs">
        <Link to={outputsPath}>Output Tags</Link>
      </Tab>
    </Tabs>
  );
};

export default withRouter(ConfigTabs);
